import { render, staticRenderFns } from "./DimensionHierarchy.vue?vue&type=template&id=3928d283&scoped=true"
import script from "./DimensionHierarchy.vue?vue&type=script&lang=js"
export * from "./DimensionHierarchy.vue?vue&type=script&lang=js"
import style0 from "./DimensionHierarchy.vue?vue&type=style&index=0&id=3928d283&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3928d283",
  null
  
)

export default component.exports